import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter
} from '@angular/core';
import {
  IAdminTokenPayload,
  IAppointment,
  IConsultation,
  INote,
  IOrder,
  ISubscription
} from '@care-portals/api-interfaces';
import { AuthFacade } from '../../../../+store/auth/auth.facade';
import { NoteFacade } from '../../../../+store/note/note.facade';
import { format } from 'date-fns';
import { CommonModule } from '@angular/common';
import { NameAvatarComponent } from '../note-avatar/note-avatar.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FormsModule } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'portals-provider-add-note',
  templateUrl: './add-note.component.html',
  styleUrls: ['./add-note.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    NameAvatarComponent,
    NzInputModule,
    NzButtonModule,
    FormsModule
  ]
})
export class AddNoteComponent implements OnInit, OnDestroy {
  @Input() customerId: string;
  @Input() consultation: IConsultation;
  @Input() appointment: IAppointment;
  @Input() order: IOrder;
  @Input() subscription: ISubscription;
  @Output() cancelled = new EventEmitter<void>();
  user: IAdminTokenPayload;
  content = '';
  isActive = false;
  id: string; // id for the note to be updated; null if new note

  constructor(
    public authFacade: AuthFacade,
    private noteFacade: NoteFacade,
    private modalService: NzModalService
  ) {
    this.isActive = true;
  }

  ngOnInit() {
    this.authFacade.user$.subscribe(res => (this.user = res));
    if (this.consultation) {
      this.customerId =
        typeof this.consultation.customer === 'string'
          ? this.consultation.customer
          : this.consultation.customer._id;
    } else if (this.appointment) {
      this.customerId =
        typeof this.appointment.relatedToLead === 'string'
          ? this.appointment.relatedToLead
          : this.appointment.relatedToLead._id;
    } else if (this.order) {
      this.customerId =
        typeof this.order?.customer === 'string'
          ? this.order.customer
          : this.order.customer._id;
    } else if (this.subscription) {
      this.customerId =
        typeof this.subscription.customer === 'string'
          ? this.subscription.customer
          : this.subscription.customer._id;
    }
  }

  ngOnDestroy(): void {
    this.isActive = false;
  }

  save() {
    let consultType;

    if (this.appointment) {
      consultType =
        'Session(' +
        format(new Date(this.appointment.reservation), 'yyyy-MM-dd') +
        ')';
    } else if (this.consultation) {
      consultType = this.consultation.type;
    } else if (this.order) {
      consultType = `Order(#${this.order.id})`;
    } else if (this.subscription) {
      consultType = `Subscription(#${this.subscription?._id})`;
    } else {
      consultType = 'General Note';
    }

    const noteDTO: Partial<INote> = {
      customer: this.customerId,
      consultation: this.consultation?._id || undefined,
      appointment: this.appointment?._id || undefined,
      order: this.order?._id || undefined,
      subscription: this.subscription?._id || undefined,
      content: this.content,
      consultType: consultType
    };

    this.noteFacade.upsertNote(noteDTO);
    this.content = '';
  }

  cancel() {
    if (!this.content?.trim()) {
      this.discardAndClose();
      return;
    }

    this.modalService.confirm({
      nzTitle: 'Discard note?',
      nzContent: 'Your draft will be lost.',
      nzOkText: 'Discard',
      nzOkDanger: true,
      nzCancelText: 'Keep Editing',
      nzOnOk: () => this.discardAndClose()
    });
  }

  private discardAndClose() {
    this.content = '';
    this.cancelled.emit();
  }
}
